<template>
  <div class="container card-container">
    <div class="card md-12">
      <div class="card-body">
        <h5 class="card-title">
          {{ $t("Setting.LicenseCard.NewLicense") }}
        </h5>

        <span
          v-if="isDisabled"
          class="card-description disabled-message"
        >
          <i
            class="fa fa-exclamation-triangle"
            aria-hidden="true"
          />
          {{ $t("Setting.LicenseCard.DisabledMessage") }}<br>
          現在この機能は開発中のため、ご利用いただけません。
        </span>

        <div class="card-text">
          <license-purchase-form
            :is-disabled="isDisabled"
          />
        </div>
      </div>
    </div>

    <div class="card md-12">
      <div class="card-body">
        <h5 class="card-title">
          {{ $t("Setting.LicenseCard.LicenseList") }}
        </h5>
        <div class="card-text">
          <license-list />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LicensePurchaseForm from '../../Admin/components/LicensePurchaseForm.vue'
import LicenseList from '../../Admin/components/LicenseList.vue'
import { mapState } from 'vuex'

export default {
  components: {
    LicensePurchaseForm,
    LicenseList
  },
  computed: {
    ...mapState('auth', [
      'customerSetting'
    ]),
    isDisabled() {
      // NOTE: 現状ライセンス機能が使えないので
      return true
      /*
      if (!this.customerSetting) return true
      return Object.entries(this.customerSetting).filter(([key, v]) => {
        return !['externalServiceId', 'purchaseType'].includes(key)
      }).some(([key, v]) => {
        return !v
      })
      */
    }
  }
}
</script>

<style lang="scss" scoped>
.disabled-message {
  color: #F01557;
}
</style>
